import { render, staticRenderFns } from "./Uploadpagem.vue?vue&type=template&id=a82cbb54&scoped=true&"
import script from "./Uploadpagem.vue?vue&type=script&lang=js&"
export * from "./Uploadpagem.vue?vue&type=script&lang=js&"
import style0 from "./Uploadpagem.vue?vue&type=style&index=0&id=a82cbb54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82cbb54",
  null
  
)

export default component.exports